/** App\Enums\FeedbackRoundStatus */
export enum FeedbackRoundStatus {
  Open = 'open',
  Completed = 'completed',
  Closed = 'closed',
  Cancelled = 'cancelled',
}
